// 9fbef606107a605d69c0edbcd8029e5d
import has from 'lodash/has';
import get from 'lodash/get';
import { router } from 'next/router';
import { breakpoints } from '@tcp/core/styles/themes/TCP/mediaQuery';
import getPdpBrandLabel from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ProductBasicInfo/helpers/ProductBasicInfoHelper';
import { getLastDateOfYear } from '@tcp/core/src/utils/utils';
import { getImageUrls } from '../../../../common/atoms/DamImage/views/DamImage';
import { getAPIConfig } from '../../../../../utils';
import { cleanUpUrl, getImageSource } from '../../../../common/atoms/DamImage/utils/DamImageUtils';

const PDPCarouselOptions = {
  CAROUSEL_OPTIONS: {
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 6,
    slide: true,
    touchMove: true,
    touchThreshold: 100,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: breakpoints.values.lg - 1,
        settings: {
          arrows: false,
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: breakpoints.values.sm - 1,
        settings: {
          arrows: false,
          slidesToShow: 2.8,
          slidesToScroll: 1,
        },
      },
    ],
  },
};

export default {
  PDPCarouselOptions,
};

export const shouldAddStrikeThroughPriceSpec = ({ offerPrice, listPrice }) => {
  return offerPrice && listPrice && offerPrice !== listPrice;
};

export const getStrikeThroughPriceSpec = ({ listPrice, currency }) => {
  return {
    priceSpecification: [
      {
        '@type': 'UnitPriceSpecification',
        price: listPrice,
        priceCurrency: currency,
        priceType: 'https://schema.org/StrikethroughPrice ',
      },
    ],
  };
};

const getPriceForVariants = (variant) => {
  return variant?.promoPrice || variant?.price || variant?.listPrice;
};

export function getVariantsForSeo(product, currency) {
  const { hostname } = getAPIConfig();
  const { state: { asPath = '' } = {} } = router || {};
  if (has(product, 'variantsSeoData')) {
    const variants = get(product, 'variantsSeoData') || [];
    if (Array.isArray(variants) && variants.length) {
      const { assetHostTCP: assetHost } = getAPIConfig();
      return variants?.map((variant) => {
        const { availability } = variant || {};
        const isAvailable = parseInt(availability, 10) > 0;
        const { desktop } = getImageUrls(
          { url: variant?.image },
          variant?.brand,
          true,
          variant?.brand
        );
        const cleanUrl = cleanUpUrl(desktop);
        const imageSource = getImageSource(
          assetHost,
          'd_pdp_img_d,f_auto,q_auto',
          cleanUrl,
          desktop
        );
        const variantBrandName = variant?.brand;
        const brandName = getPdpBrandLabel({ primaryBrand: variantBrandName });

        return {
          '@type': 'Product',
          name: `${product?.name} - ${variant?.color}`,
          description: `${variant?.description}`,
          sku: variant?.sku,
          color: variant?.color,
          isFamilyFriendly: true,
          image: imageSource,
          brand: {
            '@type': 'Brand',
            name: brandName,
          },
          offers: {
            '@type': 'Offer',
            price: getPriceForVariants(variant),
            url: `https://${hostname}${asPath}`,
            priceCurrency: currency,
            availability: `https://schema.org/${isAvailable ? 'InStock' : 'OutOfStock'}`,
            itemCondition: 'https://schema.org/NewCondition',
            priceValidUntil: getLastDateOfYear(),
            ...(shouldAddStrikeThroughPriceSpec({
              offerPrice: variant?.price,
              listPrice: variant?.listPrice,
            })
              ? getStrikeThroughPriceSpec({ listPrice: variant?.listPrice, currency })
              : {}),
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: variant?.ratingValue,
            bestRating: '5',
            reviewCount: variant?.reviewCount,
            worstRating: '1',
          },
        };
      });
    }
  }
  return [];
}
